import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";

export const Template = ({
    siteKey,
    language,
    preventSubmit,
    onUxCaptcha,
}) => html`
    <ux-iws-sf-captcha
        site-key=${ifDefined(siteKey)}
        language=${ifDefined(language)}
        ?prevent-submit=${ifDefined(preventSubmit)}
        @uxCaptcha=${ifDefined(onUxCaptcha)}
    ></ux-iws-sf-captcha>
`;
